var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4974_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 11.8125L11.8125 15.625H1.335C0.804807 15.625 0.375 15.1952 0.375 14.665V1.335C0.375 0.804807 0.804807 0.375 1.335 0.375H14.665C15.1952 0.375 15.625 0.804807 15.625 1.335V11.8125Z",
    stroke: "currentColor",
    strokeWidth: 0.746027,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9713 15.4745V11.9715H15.4094M3.8064 4.56885H12.5751M3.8064 6.85635H12.5751M3.8064 9.14385H12.5751",
    stroke: "currentColor",
    strokeWidth: 0.746027,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4974_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteOutline);
export default __webpack_public_path__ + "static/media/note-outline.48aa950269a0e0efdda7ebe3650de86c.svg";
export { ForwardRef as ReactComponent };